export enum DashboardMode {
	/** View mode */
	NORMAL = 'NORMAL',
	/** Create mode */
	CREATE = 'CREATE',
	/** Edit mode */
	EDIT = 'EDIT',
	/** Wallboard mode */
	WALLBOARD = 'WALLBOARD'
}

export interface DashboardGroupItem {
	/** Id of group */
	_id?: string
	/** Name of group */
	text: string
}

export interface DashboardTopbarItem {
	_id: string
	label: string
	index: number
}
